import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { NativeApplyModal } from './NativeApplyModal'
import type { NativeApplyOpenArgs } from './NativeApplyModal.types'
import { NativeApplyModalReactContext, type NativeApplyModalContextValue } from './NativeApplyModalContext'

export type { NativeApplyModalContextValue } from './NativeApplyModalContext'

type NativeApplyModalProviderProps = {
  children: ReactNode
}

export function NativeApplyModalProvider({ children }: Readonly<NativeApplyModalProviderProps>) {
  const [args, setArgs] = useState<NativeApplyOpenArgs | null>(null)
  const [isOpen, setIsOpen] = useState(false)

  const openNativeApply = useCallback((next: NativeApplyOpenArgs) => {
    setArgs(next)
    setIsOpen(true)
  }, [])

  const closeNativeApply = useCallback(() => {
    setIsOpen(false)
  }, [])

  const value = useMemo<NativeApplyModalContextValue>(
    () => ({
      openNativeApply,
      closeNativeApply,
      isOpen
    }),
    [openNativeApply, closeNativeApply, isOpen]
  )

  return (
    <NativeApplyModalReactContext.Provider value={value}>
      {children}
      {isOpen && args ? <NativeApplyModal open={isOpen} onClose={closeNativeApply} args={args} /> : null}
    </NativeApplyModalReactContext.Provider>
  )
}
